import { NgModule } from '@angular/core';
import { LTFilterModule } from '../filter/lt-filter.module';

import { LTPngSkeletonRowComponent } from './components/lt-png-skeleton-row/lt-png-skeleton-row.component';

import { LtPngTableTestingComponent } from './components/lt-png-table-testing/lt-png-table-testing.component';
import { LTPngTableComponent } from './components/lt-png-table/lt-png-table.component';
import { LTColumnManagerComponent } from './components/lt-column-manager/lt-column-manager.component';
import { LTPNGTableCellComponent } from './components/lt-png-table-cell/lt-png-table-cell.component';
import { LTColumnPreviewComponent } from './components/lt-column-preview/lt-column-preview.component';
import { LTColumnControlsComponent } from './components/lt-column-controls/lt-column-controls.component';
import { LTColumnAggregateComponent } from './components/lt-column-aggregate/lt-column-aggregate.component';
import { LTPngTableActionFooterComponent } from './components/lt-png-table-action-footer/lt-png-table-action-footer.component';
import { LTPngTableExpansionFooterComponent } from './components/lt-png-table-expansion-footer/lt-png-table-expansion-footer.component';
import { LTPngTableSelectionFooterComponent } from './components/lt-png-table-selection-footer/lt-png-table-selection-footer.component';
import { LTColumnItemComponent } from './components/lt-column-item/lt-column-item.component';
// Directives
import { GridTemplateDirective } from './classes/grid-template.directive';

// Export Manager
import { LTExportManagerComponent } from './components/lt-export-manager/lt-export-manager.component';
import { LtExportConfigComponent } from './components/lt-export-config/lt-export-config.component';
import { LtExportPreviewComponent } from './components/lt-export-preview/lt-export-preview.component';
import { LtExportControlsComponent } from './components/lt-export-controls/lt-export-controls.component';
// Services
import { ColumnStateService } from './services/column-state-service.service';
import { ColumnOperationsService } from './services/column-operations-service.service';
import { GridAggregateService } from './services/grid-aggregate-service.service';
import { GridFormatterService } from './services/grid-formatter-service.service';
import { OverwritePrimeNgService } from './services/overwrite-primeng-service.service';
import { PapaParseExportService } from './services/papa-parse-export-service.service';
import { TableFilterService } from './services/table-filter-service.service';
import { TemplateRenderingService } from './services/template-rendering-service.service';
import { GridColumnStructureService } from './services/grid-column-structure-service.service';
import { LTColumnGridComponent } from './components/lt-column-grid/lt-column-grid.component';

// Facades
import { ExportManagerFacade } from './classes/export-manager.facade';
import { ColumnManagerFacade } from './classes/column-manager.facade';
import { GridSettingsFacade } from './classes/grid-settings.facade';
import { LtColumnChooserComponent } from './components/lt-column-chooser/lt-column-chooser.component';

@NgModule({
  imports: [
    LTFilterModule,
    GridTemplateDirective,
    LTPngTableComponent,
    LTPNGTableCellComponent,
    LTColumnManagerComponent,
    LTColumnPreviewComponent,
    LTColumnControlsComponent,
    LTColumnAggregateComponent,
    LTPngSkeletonRowComponent,
    LTExportManagerComponent,
    LtExportConfigComponent,
    LtExportPreviewComponent,
    LtExportControlsComponent,
    LtPngTableTestingComponent,
    LTPngTableActionFooterComponent,
    LTPngTableExpansionFooterComponent,
    LTPngTableSelectionFooterComponent,
    LTColumnGridComponent,
    LTColumnItemComponent,
    LtColumnChooserComponent,
  ],
  exports: [
    GridTemplateDirective,
    LTPngTableComponent,
    LTPNGTableCellComponent,
    LTColumnManagerComponent,
    LTColumnPreviewComponent,
    LTColumnControlsComponent,
    LTColumnAggregateComponent,
    LTPngTableActionFooterComponent,
    LTPngTableExpansionFooterComponent,
    LTPngTableSelectionFooterComponent,
    LTColumnGridComponent,
    LTColumnItemComponent,
    LTPngSkeletonRowComponent,
    LTExportManagerComponent,
    LtExportConfigComponent,
    LtExportPreviewComponent,
    LtExportControlsComponent,
    LtPngTableTestingComponent,
    LtColumnChooserComponent,
  ],
  providers: [
    ColumnStateService,
    ColumnOperationsService,
    PapaParseExportService,
    GridAggregateService,
    GridColumnStructureService,
    GridFormatterService,
    OverwritePrimeNgService,
    TableFilterService,
    TemplateRenderingService,
    ExportManagerFacade,
    ColumnManagerFacade,
    GridSettingsFacade,
  ],
})
export class LTGridModule { }